import { FC, useContext } from 'react';

import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';
import { getImageSrc } from 'dibs-buyer-layout/exports/imageHelpers';

import { ExpandableContent } from '../../components/global/ExpandableContent/ExpandableContent';

import styles from './SbRespContentModuleBase.scss';

const SB_TOP_NAV_VARIANT_MODULE_HEIGHT = 200;

type Props = {
    description: string | null;
    title: string | null;
    photo: string | null;
};

export const SbRespContentModuleBase: FC<Props> = ({ description, title, photo, children }) => {
    const { isSbTopNavVariant } = useContext(ServerVarsContext);
    const photoSrc = getImageSrc(photo, {
        width: 220,
        height: 220,
        fit: 'crop',
    });

    const MODULE_HEIGHT = title ? 130 : 120;

    return (
        <div className={styles.info}>
            {photo && (
                <img
                    className={styles.photo}
                    src={photoSrc || ''}
                    data-tn="facet-creator-picture"
                    alt={title || ''}
                />
            )}
            <ExpandableContent
                collapseHeight={
                    isSbTopNavVariant ? SB_TOP_NAV_VARIANT_MODULE_HEIGHT : MODULE_HEIGHT
                }
                dataTn="facet-creator-info"
                hideReadMoreArrow
                wrapperClassname={styles.expandableWrapper}
            >
                <div className={styles.content}>
                    {title && (
                        <div className={styles.title} data-tn="facet-creator-title">
                            {title}
                        </div>
                    )}
                    <span
                        className={styles.description}
                        dangerouslySetInnerHTML={{ __html: description || '' }}
                        data-tn="facet-creator-description"
                    />
                    {children}
                </div>
            </ExpandableContent>
        </div>
    );
};
